import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusesService {

  private _bus: ReplaySubject<any> = new ReplaySubject<any>(1);
  // ### flight LocalStorage Data Store variable Start ### //
  insuranceData: any = {
    salePrice: 0,
    currency: '',
    userCount: 0,
    pchart: []
  };

  constructor(private http: HttpClient) { }

  busSearch(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/search", model);
  }

  getBusCityCombo(filter: string): Observable<any[]> {
    return this.http.post<any[]>(environment.apiUrl + 'BusCity/getBusCityCombo', { filter });
  }

  busRecentSearch(): Observable<any> {
    return this.http.post<any[]>(environment.apiUrl + "BusBooking/getRecentSearchRecords", {});
  }

  seatLayout(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/seatLayout", model);
  }

  book(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/book", model);
  }

  busDetail(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/busDetail", model);
  }
  
  infinityCancellationPolicy(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/infinityCancellationPolicy", model);
  }

  getBusBookingRecord(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "BusBooking/getBusBookingRecord", model);
  }
  
  cancellatonPolicy(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/cancellatonPolicy", model);
  }

  cancellationData(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/cancellationData", model);
  }

  cancelTicket(model: any): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "bus/cancelTicket", model);
  }

  autoFillPaxData(model:any): Observable<any[]> {
    return this.http.post<any[]>(environment.apiUrl + 'bus/autoFillPaxData', model);
  }
}
